import React from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Layout from 'components/Layout';
import { withRouter, useParams } from 'react-router-dom';
import { SkuDetails as Details, SkuAccounting, SkuBehaviour } from 'components/Skus';
import { buildUrl } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { SkusActions } from 'state/modules/skus';
import { AssociatedTaxRuleset } from '../../../components/TaxRuleset/TaxRulesetHistory';
import PropTypes from 'prop-types';

const SkuDetails = ({ history }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const TRSEnabled = useSelector(
    (state) => state.config.settings?.core?.pricing?.tax_rules_set?.enabled || false
  );

  return (
    <Layout title={i18n.t('skus.title')}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid>
          <Typography variant="h6" gutterBottom>
            <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
              {i18n.t('skus.sku_details')}
            </Box>
          </Typography>
        </Grid>
        <Grid>
          <Can I="create" a="invoice_item_type">
            <Button
              onClick={() => {
                dispatch(SkusActions.resetOnboarding());
                history.push(buildUrl('/skus/create'));
              }}
              sx={{ textTransform: 'capitalize' }}
              variant="contained"
              color="primary"
            >
              {i18n.t('skus.create')}
            </Button>
          </Can>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ m: 0, width: '100%', mt: 1 }}>
        <Grid size={{ xs: 12, sm: 12, md: 4 }}>
          <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
            <Grid size={12}>
              <Details id={id} />
            </Grid>
            {TRSEnabled ? (
              <Grid size={12}>
                <AssociatedTaxRuleset skuId={id} />
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4 }}>
          <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
            <Can I="read" on="invoice_item_type">
              <Grid size={12}>
                <SkuAccounting id={id} />
              </Grid>
            </Can>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4 }}>
          <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
            <Can I="read" on="invoice_item_type">
              <Grid size={12}>
                <SkuBehaviour id={parseInt(id)} />
              </Grid>
            </Can>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
};

SkuDetails.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(SkuDetails);
